/**
 * body 要素に対して初期化処理を実行します。
 */
export function initBody() {
    // クラスの追加
    document.body.classList.add(`blog-id-${mtappVars.blog_id}`, `author-id-${mtappVars.author_id}`, `screen-id-${mtappVars.screen_id}`);
}
